import { mapState } from 'vuex';
import insightData from '../defs/insight.json';

export default {
  data() {
    return {
      passColor: '#89DA59',
      failColor: '#FFBA08',
      disabledColor: '#CCC',
      defs: this.$typeDefs.insights,
      insightData,
    };
  },
  computed: {
    ...mapState(['disabledControls']),
    allCount() {
      let value = 0;
      this.defs.forEach((insight) => {
        value += insight.values.length;
      });
      return value;
    },
    allFilterOptions() {
      const values = [];
      this.defs.forEach((insight) => {
        values.push({
          id: insight.id,
          icon: insight.icon,
          title: insight.shortTitle,
          length: insight.values.length,
        });
      });
      return values;
    },
  },
  methods: {
    buildAssetReport() {
      const values = [];
      this.defs.forEach((insight) => {
        insight.values.forEach((value) => {
          values.push({
            ...value,
            sectionId: insight.id,
            icon: insight.icon,
            enabled: !this.disabledControls.includes(value.id),
            pass: this.getPassFailTmp(value.id),
          });
        });
      });
      return values;
    },
    getPassFailTmp(id) {
      if (id === '1.2') {
        return false;
      }
      return true;
    },
    getPassFail(id) {
      switch (id) {
        // TODO: Apple Provided Software is Current
        case '1.1':
          return false;

        // Auto Update Enabled
        case '1.2':
          return this.insightData.softwareUpdate.AutomaticallyInstallMacOSUpdates;

        // App Updated Installs Enabled
        case '1.3':
          return this.insightData.appUpdates.AutoUpdate;

        // System Data Files and Security Installs Enabled
        case '1.4':
          return this.insightData.appUpdates.CriticalUpdateInstall;

        // macOS Update Installs Enabled
        case '1.5':
          return this.insightData.softwareUpdate.AutomaticallyInstallMacOSUpdates;

        // Bluetooth Disabled If No Devices Exist
        case '2.1.1':
          return this.insightData.systemPreferences.bluetoothPairedDevices === false
          && this.insightData.systemPreferences.bluetoothEnabled === false;

        // Bluetooth Status in Menu Bar
        case '2.1.3':
          return this.insightData.systemPreferences.bluetoothMenuMissingForUsers.length > 0;

        // TODO: Date & Time Set Automatically
        case '2.2.1':
          return false;

        // TODO: Time is Set Within Appropriate Limits
        case '2.2.2':
          return this.insightData.systemPreferences.clockDrift < 100;

        // Inactivity Interval is Set to 20 minutes or Less for the Screen Saver
        case '2.3.1':
          return this.insightData.systemPreferences.longScreensaverIdleUsers.length > 0;

        // Secure Screen Saver Corners Enabled
        case '2.3.2':
          return this.insightData.systemPreferences.insecureScreensaverCornerUsers.length > 0;

        // TODO: Remote Apple Events Disabled
        case '2.4.1':
          return false;

        // Internet Sharing Disabled
        case '2.4.2':
          return this.insightData.systemPreferences.internetSharingEnabled === false;

        // TODO: Screen Sharing Disabled
        case '2.4.3':
          return false;

        // TODO: Printer Sharing Disabled
        case '2.4.4':
          return false;

        // TODO: Remote Login Disabled
        case '2.4.5':
          return false;

        // TODO: DVD or CD Sharing Disabled
        case '2.4.6':
          return false;

        // TODO: Bluetooth Sharing Disabled
        case '2.4.7':
          return false;

        // TODO: File Sharing Disabled
        case '2.4.8':
          return false;

        // TODO: Remote Management Disabled
        case '2.4.9':
          return false;

        // Wake for Network Access Disabled
        case '2.5.1':
          return this.insightData.systemPreferences.wakeForNetworkEnabled === false;

        // FileValut Enabled
        case '2.6.1.1':
          return false;

        // TODO: Gatekeeper Enabled
        case '2.6.2':
          return false;

        // TODO: Firewall Enabled
        case '2.6.3':
          return this.insightData.systemPreferences.firewallSettings.firewallunload === 0;

        // TODO: Firewall Stealth Mode Enabled
        case '2.6.4':
          return this.insightData.systemPreferences.firewallSettings.stealthenabled === 1;

        // TODO: Reasonable Application Firewall Rules
        case '2.6.5':
          return false;

        // TODO: Time Machine Auto-Backup Enabled
        case '2.8.1':
          return false;

        // TODO: Time Machine Volumes are Encrypted
        case '2.8.2':
          return false;

        // TODO: Remote Control Infrared Receiver Paired if Enabled
        case '2.9':
          return false;

        // TODO: Secure Keyboard Entry in Terminal.app Enabled
        case '2.10':
          return false;

        // TODO: Java 6 is Not the Default Java Runtime
        case '2.11':
          return false;

        // TODO: EFI Version is Valid and Regularly Checked
        case '2.13':
          return false;

        // TODO: Security Auditing Enabled
        case '3.1':
          return this.insightData.logAndAudit.auditdEnabled;

        // TODO: Security Auditing Flags Configured
        case '3.2':
          return this.insightData.logAndAudit.auditFlags.length > 0;

        // TODO: Reasonable Security Auditing Rentention
        case '3.3':
          return false;

        // TODO: Access to Audit Records Controlled
        case '3.4':
          return false;

        // TODO: install.log Retained for 365 or More Days
        case '3.5':
          return false;

        // TODO: Firewall is Configured to Log
        case '3.6':
          return this.insightData.systemPreferences.firewallSettings.loggingoption === 1;

        // TODO: Bonjour Advertising Service Disabled
        case '4.1':
          return false;

        // TODO: Wi-fi Status in Menu Bar
        case '4.2':
          return false;

        // TODO: Http Server is Not Running
        case '4.4':
          return false;

        // TODO: NFS Server is Not Running
        case '4.5':
          return false;

        // TODO: Home Folders Are Secure
        case '5.1.1':
          return false;

        // TODO: System Wide Applications Have Appropriate Permissions
        case '5.1.2':
          return false;

        // TODO: System Folder Does Not Have World Writable Files
        case '5.1.3':
          return false;

        // TODO: Library Folder Does Not Have World Writable Files
        case '5.1.4':
          return false;

        // TODO: Account Lockout Threshhold Enabled
        case '5.2.1':
          return false;

        // TODO: Minimum Password Length Set
        case '5.2.2':
          return false;

        // TODO: Passwords Must Contain an Alphabetic Character
        case '5.2.3':
          return false;

        // TODO: Passwords Must Contain an Alphabetic Character
        case '5.2.4':
          return false;

        // TODO: Passwords Must Contain an Special Character
        case '5.2.5':
          return false;

        // TODO: Passwords Must Contain Uppercase and Lowercase Characters
        case '5.2.6':
          return false;

        // TODO: Password Age Limits Set
        case '5.2.7':
          return false;

        // TODO: Password History
        case '5.2.8':
          return false;

        // TODO: sudo Timeout Reduced
        case '5.3':
          return false;

        // TODO: Seperate Timestamps for Each User/TTY Combo Used
        case '5.4':
          return false;

        // TODO: Keychain Automatically Locked for Inactivity
        case '5.7':
          return false;

        // TODO: Keychain Automatically Locked When Computer Sleeps
        case '5.8':
          return false;

        // TODO: OCSP and CRL Certificate Checking Enabled
        case '5.9':
          return false;

        // TODO: root Account Disabled
        case '5.11':
          return false;

        // TODO: Automatic Login Disabled
        case '5.12':
          return false;

        // TODO: Password Required to Wake Computer From Sleep or Screen Saver
        case '5.13':
          return false;

        // TODO: System is Set to Hibernate
        case '5.14':
          return false;

        // TODO: Administrator Password Required for System-Wide Preferences
        case '5.15':
          return false;

        // TODO: Ability to Login to Another User\"s Active and Locked Session Disabled
        case '5.16':
          return false;

        // TODO: Custom Message for Login Screen
        case '5.17':
          return false;

        // TODO: Login Window Banner
        case '5.18':
          return false;

        // TODO: System Integrity Protection (SIP) Enabled
        case '5.23':
          return false;

        // TODO: Login Window Displayed as Name and Password
        case '6.1.1':
          return false;

        // TODO: Show Password Hints Disabled
        case '6.1.2':
          return false;

        // TODO: Guest Account Disabled
        case '6.1.3':
          return false;

        // TODO: Guests Allowed to Connect to Shared Folders Disabled
        case '6.1.4':
          return false;

        // TODO: Guest Home Folders Removed
        case '6.1.5':
          return false;

        // TODO: Filename Extensions Turned On
        case '6.2':
          return false;

        // TODO: Automatic Run of Safe Files in Safari Disabled
        case '6.3':
          return false;

        // TODO: Internet Plugins for Global Use in Safari Disabled
        case '6.4':
          return false;

        // TODO: XProtect Version Up to Date
        case '7.1':
          return false;

        // TODO: MRT Version Up to Date
        case '7.2':
          return false;

        // TODO: MRTd Running
        case '7.3':
          return false;

        // TODO: AirDrop Disabled
        case '7.4':
          return false;

        // TODO: FileVault Key Destroyed on Standby
        case '7.5':
          return false;

        // TODO: Only Signed Apps Permitted to Listen Through Firewall
        case '7.6':
          return false;

        // TODO: Previews Enabled
        case '7.7':
          return false;

        default:
          return false;
      }
    },
  },
};
